import { call, put, takeLatest } from "redux-saga/effects";
import {
  productAddSuccess,
  productAddFailure,
  productEditSuccess,
  productEditFailure,
  productDeleteSuccess,
  productDeleteFailure,
  productViewSuccess,
  productViewFailure,
  productViewAllSuccess,
  productViewAllFailure,
  productSearchViewAllSuccess,
  productSearchViewAllFailure,
  productViewByBrandIdSuccess,
  productViewByBrandIdFailure,
} from "./ProductAction";

import {
  PRODUCT_ADD_REQUEST,
  PRODUCT_EDIT_REQUEST,
  PRODUCT_DELETE_REQUEST,
  PRODUCT_VIEW_REQUEST,
  PRODUCT_VIEW_ALL_REQUEST,
  PRODUCT_SEARCH_REQUEST,
  PRODUCT_VIEW_BY_BRAND_ID_REQUEST,
} from "./ProductTypes";

import {
  AddProductEffect,
  EditProductEffect,
  DeleteProductEffect,
  ViewProductEffect,
  ViewAllProductsEffect,
  ViewAllSearchProductsEffect,
  ViewProductsByBrandIdEffect,
} from "./ProductEffect";

function* addProductSaga(action) {
  try {
    const token = localStorage.getItem("accessToken");

    const config = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : {};

    const response = yield call(AddProductEffect, action.payload, config);

    yield put(productAddSuccess(response.data));
  } 
catch (error) {
    const errorFields = error.response?.data?.errorFields || {};
    const message = error.response?.data?.message || "Failed to add product";
    yield put(
      productAddFailure({
        errormessage: message,
        errorFields,
      })
    );
  }
}

// Edit Product
function* editProductSaga(action) {
  try {
    const token = localStorage.getItem("accessToken");

    const config = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : {};

    const { productId, updates } = action.payload;
    const response = yield call(EditProductEffect, productId, updates, config);
    yield put(productEditSuccess(response.data));
  } catch (error) {
    const errorFields = error.response?.data?.errorFields || {};
    const message = error.response?.data?.message || "Failed to update product";
    yield put(
      productEditFailure({
        errormessage: message,
        errorFields,
      })
    );
  }
}

// View Product
function* viewProductSaga(action) {
  try {
    const token = localStorage.getItem("accessToken");

    const config = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : {};
    const response = yield call(ViewProductEffect, action.payload, config);
    yield put(productViewSuccess(response.data));
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || "Failed to fetch product details";
    yield put(productViewFailure({ errormessage: errorMessage }));
  }
}

// View All Products
function* viewAllProductsSaga(action) {
  try {
    const token = localStorage.getItem("accessToken");

    const config = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : {};
    const response = yield call(ViewAllProductsEffect, action.payload, config);
    

    yield put(productViewAllSuccess(response.data));
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || "Failed to fetch products";
    yield put(productViewAllFailure({ errormessage: errorMessage }));
  }
}

// View Products By Brand Id
function* viewProductsByBrandIdSaga(action) {
  try {
    const token = localStorage.getItem("accessToken");

    const config = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : {};
    const response = yield call(ViewProductsByBrandIdEffect, action.payload, config);

    yield put(productViewByBrandIdSuccess(response.data));
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || "Failed to fetch products";
    yield put(productViewByBrandIdFailure({ errormessage: errorMessage }));
  }
}

// View All Search Products
function* viewAllSearchProductsSaga(action) {
  try {
    const token = localStorage.getItem("accessToken");

    const config = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : {};
    const response = yield call(ViewAllSearchProductsEffect, action.payload, config);

    yield put(productSearchViewAllSuccess(response.data));
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || "Failed to fetch products";
    yield put(productSearchViewAllFailure({ errormessage: errorMessage }));
  }
}

// Delete Product
function* deleteProductSaga(action) {
  try {
    const token = localStorage.getItem("accessToken");

    const config = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : {};
    const response = yield call(DeleteProductEffect, action.payload, config);
    yield put(productDeleteSuccess(response.data));
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || "Failed to delete product";
    yield put(productDeleteFailure({ errormessage: errorMessage }));
  }
}


export function* ProductSaga() {
  yield takeLatest(PRODUCT_ADD_REQUEST, addProductSaga);
  yield takeLatest(PRODUCT_EDIT_REQUEST, editProductSaga);
  yield takeLatest(PRODUCT_DELETE_REQUEST, deleteProductSaga);
  yield takeLatest(PRODUCT_VIEW_REQUEST, viewProductSaga);
  yield takeLatest(PRODUCT_VIEW_ALL_REQUEST, viewAllProductsSaga);
  yield takeLatest(PRODUCT_VIEW_BY_BRAND_ID_REQUEST, viewProductsByBrandIdSaga);
  yield takeLatest(PRODUCT_SEARCH_REQUEST, viewAllSearchProductsSaga);
}
